let frontEndConfig = {
	'bugsnag': {
		'apiKey' : '67ed6388c4890c56e7ff8d1c4b0fb82d',
		'releaseStage' : 'onpeak'
	},
	'intercom': {
		'enabled': false,
		'appId': 'fgb493xu'
	},
	"keen" : {
			"projectId" : "59b01426c9e77c0001f18742",
			"writeKey" : "D4D7D44D6EDB602A263113375CD19FB962675BBA48AC6DF637EA31483F08DA133113D88B5791DBFF4EAADE6A1882A5837AA7B6A8515244FC9636C83B913DDC77EAE64E4D2CE7455CD7AA5D538A9D62C96EAD076B3F7C3DE5F8FC8C902F2C0BEA"
	}
};

export default frontEndConfig;
